module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "calendar"
  }, [_c('div', {
    staticClass: "background"
  }, [_c('background-vector', {
    staticClass: "calendar__vector",
    attrs: {
      "alpha": 0.15,
      "scale": _vm.background.scale,
      "viewbox": _vm.background.viewbox,
      "rotate": 75
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "background__banner calendar__banner"
  }, [_vm._v(_vm._s(_vm.content.banner))])], 1), _vm._v(" "), _c('div', {
    staticClass: "calendar__content"
  }, [_c('router-view')], 1), _vm._v(" "), _c('header-nav'), _vm._v(" "), _c('footer-nav', {
    attrs: {
      "sidebars": _vm.sidebars
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a076cd4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/events/Events.vue
// module id = 649
// module chunks = 1